import './pageTopBlock/breadcrumbs/breadcrumbs.css';
import './pageTopBlock/hotelDetails/hotelDetails.scss';
import '@/js/common/components/reviewsColor/reviewsColor.scss';
import './pageTopBlock/hotelContent/hotelContent.css';
import './hotelContent/filterGroup/filterGroup.scss';
import './hotelContent/hotelTourList/hotelTourList.scss';
import './aboutHotel/aboutHotel.css';
import './hotelMap/hotelMap.css';
import './progressBar/progressBar.scss';
import './hotel.scss';